import { Component, Input, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from '../../services/helpers.service';
import { OrdersService } from '../../services/orders.service';

@Component({ standalone: false,
  selector: 'vfa-cp-ty-onboarding-modal',
  templateUrl: './ty-onboarding-modal.component.html',
  styleUrls: ['./ty-onboarding-modal.component.scss'],
})
export class TyOnboardingModalComponent {
  @ViewChild('confirmModal') confirmModal: any;

  public isInsuranceAvailable!: boolean;
  public order: any;

  constructor(private modalService: NgbModal,
              private helpersService: HelpersService,
              private ordersService: OrdersService) {}

  public openModal(isInsuranceAvailable: boolean, order: any) {
    this.isInsuranceAvailable = isInsuranceAvailable;
    this.order = order;
    this.modalService.open(this.confirmModal, { keyboard: false, centered: true, size: 'xl', backdropClass: "bg-modal" });
  }

  public closeModal() {
    this.modalService.dismissAll();
  }
  
  public submitConfirmation() {
    let data = {
      machine: this.helpersService.STATE_MACHINE,
      id: null
    }
    if (this.ordersService.storageDiscountKey) {
      localStorage.removeItem(this.ordersService.storageDiscountKey);
    }
    if(this.isInsuranceAvailable) {
      data.id = this.order.NE__OrderId__r.Id
      this.ordersService.updateUserState('INSURANCE', data);
    } else {
      this.ordersService.updateUserState('ONBOARDING_FINAL', data, '/dashboard');
    }
  }
}

